export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/bookings-clock-icon.de258fb1.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};